var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.5749 8.25948L5.77676 8.25948C4.2922 8.25948 3.54844 10.0541 4.59779 11.1043L8.9952 15.505C9.64601 16.1563 10.7016 16.1565 11.3527 15.5055L15.7535 11.1047C16.8034 10.0547 16.0598 8.25948 14.5749 8.25948Z"}));
}

ChevronDown.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"#001D3B"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
